// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.header[data-v-dad57724] {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  margin: auto;
  display: flex;
  height: 5.75rem;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
  transition-property: all;
  transition-duration: 150ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@media (min-width: 1536px) {
.header[data-v-dad57724] {
    padding-left: 12.5rem;
    padding-right: 12.5rem;
}
}
.header[data-v-dad57724] {
  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.04);
}
.header__logo[data-v-dad57724] {
  width: 7rem;
}
@media (min-width: 640px) {
.header__logo[data-v-dad57724] {
    width: 9.375rem;
}
}
.header__right-actions[data-v-dad57724] {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
@media (min-width: 996px) {
.header__right-actions[data-v-dad57724] {
    padding-right: 164px;
}
}
.header__we-call-you[data-v-dad57724] {
  position: absolute;
  right: 1rem;
  display: none;
}
@media (min-width: 996px) {
.header__we-call-you[data-v-dad57724] {
    display: flex;
}
.header__we-call-you--mobile[data-v-dad57724] {
    display: none;
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/Header.vue"],"names":[],"mappings":";AA6DA;EAAA,gBAAA;EAAA,MAAA;EAAA,OAAA;EAAA,WAAA;EAAA,YAAA;EAAA,aAAA;EAAA,eAAA;EAAA,WAAA;EAAA,mBAAA;EAAA,8BAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,6CAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,wDAAA;AAAA;AAAA;AAAA;IAAA,qBAAA;IAAA,sBAAA;AAAA;AAAA;AADA;EAEA,4CAAA;AAiBA;AAdA;EAAA,WAAA;AAAA;AAAA;AAAA;IAAA,eAAA;AAAA;AAAA;AAIA;EAAA,kBAAA;EAAA,aAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,qBAAA;OAAA,gBAAA;AAAA;AAAA;AAAA;IAAA,oBAAA;AAAA;AAAA;AAIA;EAAA,kBAAA;EAAA,WAAA;EAAA,aAAA;AAAA;AAAA;AAAA;IAAA,aAAA;AAAA;AAGA;IAAA,aAAA;AAAA;AAHA","sourcesContent":["<template>\n  <header class=\"header\">\n    <a href=\"/\"><Logo class=\"header__logo\"/></a>\n    <div class=\"header__right-actions\">\n      <WeCallYou class=\"header__we-call-you\" />\n      <WeCallYou class=\"header__we-call-you--mobile\" />\n      <Menu v-model=\"display\" :elements=\"elements\" />\n    </div>\n  </header>\n</template>\n\n<script>\nimport { ref } from '@vue/composition-api';\nimport route from '@/route.js';\nimport Icon from '@/lego/components/icons/Icon.vue';\nimport Menu from '@/lego/components/menus/Menu.vue';\nimport Logo from '@/lego/components/layout/Logo.vue';\nimport WeCallYou from '@/lego/partials/home/WeCallYou.vue';\n\nexport default {\n  components: {\n    Icon,\n    Menu,\n    Logo,\n    WeCallYou,\n  },\n  setup() {\n    return {\n      display: ref(false),\n      elements: {\n        Simula: [\n          {\n            'Nueva hipoteca': route('new-mortgage-page.index'),\n            'Mejora de condiciones': route('funnel.improve'),\n            Calculadora: route('calculator.view'),\n          },\n        ],\n        Servicios: [\n          {\n            'Tasación oficial': route('official-appraisal.view'),\n            'Tasación online': route('appraisal.view'),\n          },\n        ],\n        Nosotros: route('about'),\n        Recursos: [\n          {\n            Blog: route('posts.index'),\n            'Centro de Estudios':\n              'https://blog.trioteca.com/centro-de-estudios-de-trioteca/',\n            'Curso hipotecario': route('mortgageCourse.index'),\n            Webinars: route('webinars.index'),\n          },\n        ],\n      },\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.header {\n  @apply z-10 m-auto justify-between transition-all ease-in-out top-0 left-0 sticky items-center flex px-xxxs 2xl:px-giant w-full h-[5.75rem] bg-neutral-white text-neutral-ultradark;\n  box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.04);\n\n  &__logo {\n    @apply w-[7rem] sm:w-[9.375rem];\n  }\n\n  &__right-actions {\n    @apply relative flex flex-row items-center gap-x-xxxs lg:pr-[164px] h-full;\n  }\n\n  &__we-call-you {\n    @apply absolute right-xxxs hidden lg:flex;\n\n    &--mobile {\n      @apply lg:hidden;\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
